var exports = {
  "X7": "UserProfileBadges.module__containerModal___RDJMMW",
  "j4": "UserProfileBadges.module__containerModalMobile___RDJMMW",
  "pP": "UserProfileBadges.module__containerModalDesktop___RDJMMW",
  "Ub": "UserProfileBadges.module__pending___RDJMMW",
  "RS": "UserProfileBadges.module__containerPopout___RDJMMW",
  "Qk": "UserProfileBadges.module__badgeMobile___RDJMMW",
  "EJ": "UserProfileBadges.module__badgeDesktop___RDJMMW",
  "SI": "UserProfileBadges.module__captionBadge___RDJMMW",
  "Kd": "UserProfileBadges.module__captionBadgeMobile___RDJMMW",
  "eA": "UserProfileBadges.module__captionBadgeDesktop___RDJMMW",
  "nf": "UserProfileBadges.module__link___RDJMMW",
  "$J": "UserProfileBadges.module__linkButton___RDJMMW",
  "zH": "UserProfileBadges.module__details___RDJMMW",
  "i5": "UserProfileBadges.module__detailsArt___RDJMMW",
  "x2": "UserProfileBadges.module__detailsTitle___RDJMMW",
  "L4": "UserProfileBadges.module__detailsLine___RDJMMW",
  "r9": "UserProfileBadges.module__editButton___RDJMMW",
  "IZ": "UserProfileBadges.module__editIcon___RDJMMW",
};

module.exports = exports;
